import LeadCard from "@pages/Global/components/LeadCard";
import SmallCard from "@pages/Global/components/SmallCard";

/**
 * Handle to returns the appropriate card component based on the index for the Global page.
 * The first card is a LeadCard, and all subsequent cards are SmallCards.
 * This is used to render the Top Stories, Companies and Tech Section
 */
export const getCardLayout = (index: number) => {
  switch (index) {
    case 0:
      return LeadCard;
    default:
      return SmallCard;
  }
};

/**
 * Returns the order for the top stories card based on the index.
 * This is used to control the layout of the top stories section.
 */
export const getTopStoriesCardPostion = (index: number) => {
  switch (index) {
    case 0:
      return "lg:order-2 lg:col-span-4 lg:row-span-4";

    case 1:
    case 3:
    case 5:
    case 7:
      return "col-span-2 lg:order-1";

    default:
      return "col-span-2 lg:order-3";
  }
};
